import ActivityIcon from '@/components/icons/activity';
import FormTemplateIcon from '@/components/icons/form-template';
import { TopbarTab } from '@/components/topbar/topbar';
import { getWorkspaceRoute } from '@/utils/routes';

export function TopbarActions() {
  return (
    <div className="flex h-full items-center">
      <TopbarTab href={getWorkspaceRoute('/inspections/activity')} label="Inspection Activity" icon={<ActivityIcon />} />
      <TopbarTab href={getWorkspaceRoute('/inspections/forms')} label="Inspection Forms" icon={<FormTemplateIcon />} />
    </div>
  );
}
